import React from 'react';
import Icon from 'atomic/icon';
import { newsletterResponseSuccessData } from 'components/newsletter/newsletter-response-success/newsletter-response-success.data';

import './newsletter-response-success.scss';

const NewsletterResponseSuccess: React.FC = () => (
    <div className="newsletter-response-success">
        <Icon
            className="newsletter-response-success__icon"
            name="check-circle"
            size={24}
            color="fourth"
        />
        <p className="newsletter-response-success__title">
            {newsletterResponseSuccessData.title}
        </p>
        <p className="newsletter-response-success__text">
            {newsletterResponseSuccessData.text}
        </p>
        <p>
            {newsletterResponseSuccessData.message}
        </p>
    </div>
);

export default NewsletterResponseSuccess;
